import React from 'react';
import core from '@gin-betting/core';

import { ErrorBoundary } from 'components';

const {
    utils: { getDisplayName },
    hocs: { extendHOC },
} = core;

function withErrorBoundary(WrappedComponent: React.ComponentType) {
    const name = getDisplayName(WrappedComponent);

    class ErrorBoundaryWrapper extends React.Component {
        render() {
            return (
                <ErrorBoundary wrappedComponentName={name}>
                    <WrappedComponent {...this.props} />
                </ErrorBoundary>
            );
        }
    }

    return extendHOC(WrappedComponent, ErrorBoundaryWrapper);
}

export default withErrorBoundary;
